import { useState, useEffect } from 'react'

const QUERY = '(max-width: 767px)'

/**
 * True when viewport is below Tailwind's `md` breakpoint (768px).
 */
export function useMaxMd(): boolean {
  const [maxMd, setMaxMd] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia(QUERY).matches : false
  )

  useEffect(() => {
    const mq = window.matchMedia(QUERY)
    setMaxMd(mq.matches)
    const fn = () => setMaxMd(mq.matches)
    mq.addEventListener('change', fn)
    return () => mq.removeEventListener('change', fn)
  }, [])

  return maxMd
}
